import { Link } from "../../components/atoms/Link";
import { Divider } from "../../components/atoms/Divider";
import { Heading } from "../../components/atoms/Heading";
export var DSLRules = [{
  token: 'link',
  component: Link,
  content: true,
  defaultProps: {
    target: '_self'
  },
  props: [{
    name: 'href',
    required: true
  }, {
    name: 'target',
    content: ['_blank', '_self', '_parent', '_top']
  }]
}, {
  token: 'hr',
  component: Divider
}, {
  token: 'h1',
  component: Heading,
  content: true,
  defaultProps: {
    h: '1'
  }
}, {
  token: 'h2',
  component: Heading,
  content: true,
  defaultProps: {
    h: '2'
  }
}, {
  token: 'h3',
  component: Heading,
  content: true,
  defaultProps: {
    h: '3'
  }
}, {
  token: 'h4',
  component: Heading,
  content: true,
  defaultProps: {
    h: '4'
  }
}, {
  token: 'h5',
  component: Heading,
  content: true,
  defaultProps: {
    h: '5'
  }
}, {
  token: 'br',
  component: 'br'
}, {
  token: 'medium',
  component: 'b',
  content: true
}, {
  token: 'bold',
  component: 'strong',
  content: true
}, {
  token: 'sup',
  component: 'sup',
  content: true
}, {
  token: 'sub',
  component: 'sub',
  content: true
}];
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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